module.exports = __webpack_public_path__ + "static/media/YF47_4.9398474e.jpg";